exports.host = process.env.VUE_APP_SITE_HOST_NAME;
exports.siteUrl = process.env.VUE_APP_SITE_HOST_NAME_LOCAL;
exports.baseUrl= process.env.VUE_APP_API_BASE_GOENROLL
exports.Domain = process.env.VUE_APP_SITE_DOMAIN_GOENROLL
exports.benefitBaseUrl = process.env.VUE_APP_API_BASE_BENEFIT
 